<template>
  <div class="e-content-header">
    <div v-if="$slots.prepend" class="e-content-header__prepend">
      <slot name="prepend" />
    </div>
    <div class="e-content-header__main">
      <slot>
        <div v-if="avatar || icon || title || subtitle" class="e-content-header__main-container">
          <div v-if="avatar || icon" class="e-content-header__avatar">
            <e-avatar v-bind="_avatarProps" />
          </div>
          <div
            v-if="title || subtitle"
            :class="{
              'e-content-header__content': true,
              'e-content-header__content--has-title': !!title,
              'e-content-header__content--has-subtitle': !!subtitle,
            }"
          >
            <div v-if="title" class="e-content-header__title">
              {{ title }}
            </div>
            <div v-if="subtitle" class="e-content-header__subtitle">
              {{ subtitle }}
            </div>
          </div>
        </div>
      </slot>
    </div>
    <div v-if="$slots.actions" class="e-content-header__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import { EAvatar } from '../EAvatar'

export default {
  name: 'EContentHeader',

  components: {
    EAvatar,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    subtitle: {
      type: String,
      default: '',
    },

    icon: {
      type: String,
      default: undefined,
    },

    avatar: {
      type: String,
      default: undefined,
    },

    avatarProps: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    _avatarProps() {
      return {
        src: this.avatar,
        icon: this.icon,
        size: 32,
        fontSize: 16,
        ...this.avatarProps,
      }
    },
  },
}
</script>
